const form = {
  Overlay: [
    {
      type: 'Status',
      // ico: 'fas fa-ship mr-2',
      id: 'Estatus',
      number: 'Shipment Number'
    },
    {
      label: 'OnTime',
      type: 'Time',
      id: 'Progress'
    },
    {
      label: 'Cargo Ready',
      type: 'Tittle',
      ico: 'fas fa-warehouse mr-2',
      id: 'CargoReadyDate'
    },
    {
      label: 'From',
      type: 'Tittle',
      ico: 'fas fa-map-marker-alt mr-2',
      id: 'OriginName'
    },
    {
      label: 'Carrier',
      type: 'Tittle',
      ico: 'fas fas fa-truck-moving mr-2',
      id: 'Carrier'
    },
    {
      label: 'To',
      type: 'Tittle',
      ico: 'fas fa-map-marker-alt mr-2',
      id: 'destinationName'
    },
    {
      label: 'ETD',
      type: 'Tittle',
      ico: 'fas fas fa-long-arrow-alt-down mr-2',
      id: 'ETD'
    },
    {
      label: 'ETA',
      type: 'Tittle',
      ico: 'fas fa-long-arrow-alt-up mr-2',
      id: 'ETA'
    },
    {
      label: 'ATD',
      labelTe: 'PickUp',
      type: 'Tittle',
      ico: 'fas fa-long-arrow-alt-down mr-2',
      id: 'ATD',
      idTe: 'FRDPP'
    },
    {
      label: 'ATA',
      labelTe: 'ATA to Final Destination',
      type: 'Tittle',
      ico: 'fas fa-long-arrow-alt-up mr-2',
      id: 'ATA',
      idTe: 'ATA'
    },
  ]
}

export default form;